<template>
  <div>
    <a-spin :spinning="spinning" tip="加载中...">
      <p>{{$t('报名须知：团体项目，请检查报名人数是否满足，若符合报名要求，即可进入到最后一步，下载凭证，若无法进入到下一步，请检查报名信息')}}</p>
      <p v-if="matchInfo.signCostStatus !== 'FREE'">{{ matchFun.getPayType(matchInfo.signCostStatus) }}<a-icon type="search" style="margin-left: 10px;" @click="$refs.signupPayModelData.show()"/></p>
      <div v-if="matchInfo.mode === 'ONLINE' && onlineSetting.isChoose === 1" style="margin-bottom:10px;">
        <div v-if="Object.keys(this.singleData).length >= onlineSetting.num">
          报名人数已达到{{ onlineSetting.num }}人以上，可提交一名大众裁判，参与打分（注：重复提交将会覆盖之前提交的裁判）
          <a-button @click="$refs.onlinePublic.show()">去提交<a-icon type="double-right" /></a-button>
        </div>
        <div v-else>提交大众裁判要求：报名{{ onlineSetting.num }}人以上</div>
      </div>
      <a-collapse default-active-key="-1" :bordered="false" style="background-color: #fff;">
        <template #expandIcon="props">
          <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
        </template>
        <a-collapse-panel key="-1" :style="customStyle">
          <span slot="header">
            <a-checkbox @click.stop="" :indeterminate="!!checkCardIds.length && checkCardIds.length < Object.keys(singleData).length" :checked="checkAll" @change="changeCardAll($event)"></a-checkbox>
            &ensp;{{$t('运动员参赛信息')}}
            <span style="float:right;">{{$t('报名总人数')}}：{{ Object.keys(singleData).length }}人</span>
          </span>
          <div v-for="(item,index) in singleData" :key="index" style="margin-bottom:10px;border-bottom: 1px solid #e8e8e8;line-height: 35px;padding-bottom: 10px;overflow: hidden;">
            <a-checkbox @click.stop="" @change="changeCard($event,item)" :checked="checkCardIds.indexOf(item.cardId) > -1" style="float:left;margin-left:24px;"></a-checkbox>
            <img :src="item.head" style="width:35px;height:35px;border-radius:5px;margin-left:10px;float:left;"/>
            <div style="margin-left:10px;width:90px;float:left;overflow: hidden;height: 35px;">{{ item.name }}</div>
            <div style="width:77px;float:left;" v-if="matchInfo.insuranceStatus === '0' || matchInfo.insuranceStatus === '1'">保险:
              <font v-if="item.insuranceStatus === 1" color="#87d068">已购买</font>
              <font v-else color="#f50">未购买</font>
            </div>
            <div style="margin-left:20px;width:750px;float:left;">
              <a-tag color="blue" v-for="(it,ind) in item.combat" :key="ind" style="margin-right:10px;">
                {{ it.name }}{{ calWeightVal(item.cardId, it.combatDetailId) }}
                &ensp;
                <font color="#87d068" v-if="matchInfo.signCostStatus === 'FREE'"></font>
                <font color="#87d068" v-else-if="it.signStatus === 1">已缴费</font>
                <font color="#f50" v-else>未缴费！</font>
              </a-tag>
            </div>
            <div style="float:right;width:136px;">
              <a-button icon="edit" size="small" type="primary" @click="edit(item)">编辑</a-button>
              <a-popconfirm
                title="确定要删除吗?"
                @confirm="() => delPlayer(item)"
              >
                <a-button icon="delete" size="small" type="danger">删除</a-button>
              </a-popconfirm>
            </div>
          </div>
        </a-collapse-panel>
        <a-collapse-panel :key="item.key" v-for="item in teamData" :style="customStyle">
          <span slot="header" style="padding: 20px;">
            <div style="width:500px;float: left;">
              {{ item.combatName }}{{ item.combatDetailName }}{{ item.sex === 1 ? '男子' : (item.sex === 2 ? '女子' : '') }}{{ item.weight }}
              {{ item.teamNumber > 1 ? item.teamNumber + '小队' : '' }}
            </div>
            <span style="float:right;">
              已报：{{ item.players.length }}人
              &ensp;&ensp;{{ getJoinPlayerNumTips(item)}}
              <a-tag v-if="!item.playerNumberPass" color="#f50">
              不满足人数限制，请检查 !
              </a-tag>
              <a-tag v-else color="#87d068">
              人数满足
              </a-tag>
              <span v-html="getJoinAppoint(item)"></span>
            </span>
          </span>
          <div v-for="(it,ind) in item.players" :key="ind" style="margin-bottom:10px;line-height: 35px;width: 130px;float: left;margin:10px 0px 20px 0;;">
            <img :src="it.head" style="width:35px;height:35px;border-radius:5px;margin-left:10px;float:left;"/>
            &ensp;{{ it.name }}
            <span v-if="Number($route.query.programId) === 12">
              <a-select v-model="it.weight" size="small" @change="changeWeight($event, item, it)" style="width: 80px;margin-left:10px;">
                <a-select-option v-for="(ite,inde) in weightArr(item.weight)" :value="ite" :key="inde">
                  {{ ite }}
                </a-select-option>
              </a-select>
            </span>
          </div>
        </a-collapse-panel>
      </a-collapse>
      <div style="height:35px;">
        <span v-if="Object.keys(this.singleData).length > 0">
          <a-button v-if="matchInfo.signCostStatus !== 'FREE'" icon="money-collect" type="primary" @click="checkSign">选中项缴纳报名费</a-button>
          <a-divider v-if="matchInfo.signCostStatus !== 'FREE'" type="vertical" />
          <BuyInsuranceBtn v-if="matchInfo.insuranceStatus === '0' || matchInfo.insuranceStatus === '1'" ref="buyInsuranceBtn" :needPhonePlayers="needPhonePlayers" name="选中项缴纳保险" @buyInsurance="buyInsurance"/>
        </span>
        <a-checkbox v-if="matchInfo.insuranceStatus !== '2'" :checked="bxChecked" @change="bxChange" style="float:right;">
          {{$t('我已查看并同意')}}
          <!-- <a href="http://mechanism.daoba.com/word/tiaokuan.doc">“{{$t('保险条款')}}”</a>
          <a-divider type="vertical"/> -->
          <a href="https://static.daoba.com//791546521809.docx">“{{$t('客户告知书')}}”</a>
        </a-checkbox>
      </div>
      <PayQrCode ref="payQrCode" @paySuccess="paySuccess"/>
    </a-spin>
    <div v-if="noExamineList.length > 0">
      <p>注：审核不通过的视频如下，请重新录制好视频后，重新报名</p>
      <a-list item-layout="horizontal" :data-source="noExamineList">
        <a-list-item slot="renderItem" slot-scope="item">
          <a-list-item-meta
            :description="item.combat"
          >
            <span slot="title">{{ item.playerName }}&ensp;<a target="_black" :href="item.video">查看视频</a></span>
            <a-avatar
              slot="avatar"
              :src="item.playerImage"
            />
          </a-list-item-meta>
        </a-list-item>
      </a-list>
    </div>
    <a-button icon="download" @click="joinOk" style="float:right;top: 19px;margin-left:10px;background-color: #b80000;border:1px solid #b80000;" type="primary">{{$t('报名完成下载凭证')}}</a-button>
    <SignupPayModelData ref='signupPayModelData'/>
    <OnlinePublic ref='onlinePublic'/>
    <InsuranceType ref="insuranceType" @insuranceTypeOk="insuranceTypeOk"></InsuranceType>
  </div>
</template>
<script>
import store from '@/store'
import matchFun from '@comm/utils/matchFun'
import PayQrCode from '../pay/PayQrCode'
import OnlinePublic from './OnlinePublic'
import BuyInsuranceBtn from '../pay/BuyInsuranceBtn'
import InsuranceType from '@comm/components/join/pay/InsuranceType'
import SignupPayModelData from '@comm/components/join/pay/SignupPayModelData'
export default {
  components: {
    PayQrCode,
    BuyInsuranceBtn,
    InsuranceType,
    SignupPayModelData,
    OnlinePublic
  },
  data () {
    return {
      matchFun: matchFun,
      spinning: false,
      singleData: {},
      teamData: [],
      checkCardIds: [],
      checkAll: false,
      customStyle: 'background: #f7f7f7;border-radius: 4px;margin-bottom: 24px;border: 0;overflow: hidden',
      matchInfo: store.getters['match/matchInfo'],
      accountId: store.getters['user/accountId'],
      agencyId: Number(this.$route.query.agencyId),
      matchId: this.$route.query.matchId,
      needPhonePlayers: [],
      bxChecked: false,
      onlineSetting: {
        isChoose: 0,
        num: 1
      },
      onlinePublic: {
        agencyId: Number(this.$route.query.agencyId),
        matchId: this.$route.query.matchId,
        name: '',
        mobile: ''
      },
      noExamineList: [],
      appointList: [],
      weightList: []
    }
  },
  mounted () {
    // 个人报名
    this.findData()
    if (this.matchInfo.mode === 'ONLINE') {
      this.videoNoExamine()
      this.videoOnlineSetting()
    }
  },
  methods: {
    videoOnlineSetting () {
      this.$api.join.empowerOnlineFindSetting({matchId: this.$route.query.matchId}).then(res => {
        if (res.status === 0 && res.data !== null) {
          this.onlineSetting.isChoose = res.data.isChoose
          this.onlineSetting.num = res.data.num
        }
      })
    },
    videoNoExamine () {
      this.$api.join.queryJoinVideoNoExamine({matchId: this.$route.query.matchId, agencyId: this.$route.query.agencyId, customerId: this.accountId}).then(res => {
        if (res.status === 0) {
          this.noExamineList = res.data
        }
      })
    },
    weightArr (weight) {
      return weight.split('/')
    },
    getJoinAppoint (item) {
      // 短兵指定项目公斤级
      if (Number(this.$route.query.programId) === 12) {
        let bool = 0
        let weightArr = []
        item.players.forEach(ele => {
          if (!ele.weight) {
            bool = 1
          } else {
            if (weightArr.indexOf(ele.weight) === -1) {
              weightArr.push(ele.weight)
            }
          }
        })
        if (item.minNumber > weightArr.length) {
          return '<font color="red">请至少有' + item.minNumber + '人选择不同的级别，请检查</font>'
        }
        if (bool === 1) {
          return '<font color="red">还有选手未指定公斤级</font>'
        }
      }
      return ''
    },
    changeWeight (e, item, it) {
      let valData = {
        matchId: this.$route.query.matchId,
        agencyId: this.$route.query.agencyId,
        teamId: this.$route.query.teamId,
        teamNumber: item.teamNumber,
        combatId: item.combatId,
        combatDetailId: item.combatDetailId,
        cardId: it.cardId,
        weight: e
      }
      this.$api.join.joinAppointWeight(valData).then(res => {
        if (res.status === 0) {
          this.$message.success('成功')
          this.findAppointWeight()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    findAppointWeight () {
      this.$api.join.findAppointWeight({matchId: this.$route.query.matchId, agencyId: this.$route.query.agencyId, teamId: this.$route.query.teamId}).then(res => {
        if (res.status === 0) {
          this.appointList = res.data
          this.teamData.forEach(element => {
            element.players.forEach(ele => {
              let arr = this.appointList.filter(item => item.combatDetailId === element.combatDetailId && item.cardId === ele.cardId)
              if (arr.length > 0) {
                ele.weight = arr[0].weight
              }
            })
          })
          this.$forceUpdate()
        }
      })
    },
    findThreeJoinWeight () {
      this.$api.join.findThreeJoinWeight({matchId: this.$route.query.matchId, agencyId: this.$route.query.agencyId}).then(res => {
        if (res.status === 0) {
          this.weightList = res.data
        }
      })
    },
    findPersonal () {
      this.teamData = []
      this.singleData = {}
      this.spinning = true
      this.$api.join.queryPersonalPlayList({matchId: this.$route.query.matchId, customerId: this.accountId}).then(res => {
        this.spinning = false
        if (res.status === 0) {
          let key = 1
          res.data.forEach(element => {
            element.key = key
            key++
            element.players.forEach(ele => {
              let combat = {
                name: element.combatName + element.combatDetailName + (element.sex === 1 ? '男子' : (element.sex === 2 ? '女子' : '')) + element.weight + (element.teamNumber > 1 ? element.teamNumber + '小队' : ''),
                signStatus: ele.signStatus,
                combatId: element.combatId,
                combatDetailId: element.combatDetailId,
                teamId: -1
              }
              if (this.singleData[ele.cardId] === undefined) {
                ele.combat = [combat]
                this.singleData[ele.cardId] = ele
              } else {
                this.singleData[ele.cardId].combat.push(combat)
              }
            })
            // 如果是团队项目
            if (element.identity > 2) {
              this.teamData.push(element)
            }
          })
        }
      }).catch(err => {
        console.log(err)
      })
    },
    findData () {
      if (Number(this.$route.query.programId) === 12) {
        this.$warning({
          title: '报团体项目的请注意',
          content: '请完善团队中每个成员的公斤级（运动员参赛信息下方，点击展开查看团队信息，即可设置）'
        })
      }
      if (this.agencyId === -1) {
        this.findPersonal()
      } else {
        this.teamData = []
        this.singleData = {}
        this.spinning = true
        this.$api.join.querySmallBallPayList({matchId: this.$route.query.matchId, agencyId: this.$route.query.agencyId}).then(res => {
          this.spinning = false
          if (res.status === 0) {
            let key = 1
            res.data.forEach(element => {
              element.key = key
              key++
              element.players.forEach(ele => {
                let combat = {
                  name: element.combatName + element.combatDetailName + (element.sex === 1 ? '男子' : (element.sex === 2 ? '女子' : '')) + element.weight + (element.teamNumber > 1 ? element.teamNumber + '小队' : ''),
                  signStatus: ele.signStatus,
                  combatId: element.combatId,
                  combatDetailId: element.combatDetailId,
                  teamId: element.teamId
                }
                if (this.singleData[ele.cardId] === undefined) {
                  ele.combat = [combat]
                  this.singleData[ele.cardId] = ele
                } else {
                  this.singleData[ele.cardId].combat.push(combat)
                }
              })
              // 如果是团队项目
              if (element.identity > 2) {
                this.teamData.push(element)
              }
            })
            // 短兵指定项目公斤级
            if (Number(this.$route.query.programId) === 12) {
              this.findAppointWeight()
            }
            this.findThreeJoinWeight()
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    calWeightVal (cardId, combatDetailId) {
      if (this.weightList.length === 0) {
        return ''
      }
      let arr = this.weightList.filter(function (item){
        return item.cardId === cardId && item.combatDetailId === combatDetailId
      })
      if (arr.length > 0) {
        return arr[0].weight + 'KG'
      }
      return ''
    },
    changeCard (e, item) {
      if (e.target.checked) {
        this.checkCardIds.push(item.cardId)
      } else {
        this.deleteArr(item.cardId)
      }
      this.checkAll = this.checkCardIds.length === Object.keys(this.singleData).length
    },
    changeCardAll (e) {
      this.checkAll = e.target.checked
      this.checkCardIds = []
      if (this.checkAll) {
        this.checkCardIds = Object.keys(this.singleData).map(i => parseInt(i, 0))
      }
      this.$forceUpdate()
    },
    deleteArr (key) {
      for (var i = 0; i < this.checkCardIds.length; i++) {
        if (this.checkCardIds[i] === key) {
          this.checkCardIds.splice(i, 1)
        }
      }
    },
    checkSign () {
      if (this.checkCardIds.length === 0) {
        this.$message.error('请选择缴纳报名费的运动员')
        return
      }
      let arr = []
      for (let key in this.singleData) {
        if (this.checkCardIds.indexOf(Number(key)) > -1) {
          this.singleData[key].combat.forEach(element => {
            if (element.signStatus !== 1 && arr.indexOf(Number(key)) === -1) {
              arr.push({
                cardId: key,
                combatId: element.combatId,
                combatDetailId: element.combatDetailId,
                teamId: element.teamId
              })
            }
          })
        }
      }
      if (arr.length === 0) {
        this.$message.error('暂无缴纳报名费的运动员')
      }
      this.spinning = true
      this.$api.join.createSignUpOrder({matchId: this.$route.query.matchId, agencyId: this.$route.query.agencyId, players: arr, payType: 'PC'}).then(res => {
        this.spinning = false
        if (res.status === 0) {
          this.$refs.payQrCode.show(res.data)
        } else {
          this.$message.error(res.msg)
          this.findData()
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 获得队伍参赛人数限制提示信息
    getJoinPlayerNumTips (team) {
      var minNum = team.minNumber
      var maxNum = team.maxNumber
      var identity = team.identity
      if (identity <= 2) {
        return '无人数限制'
      } else {
        if (minNum == maxNum) {
          return '人数限制：' + minNum + '人'
        } else {
          return '人数最少：' + minNum + '人, 最多：' + maxNum + '人'
        }
      }
    },
    delPlayer (item) {
      let valData = {
        matchId: this.$route.query.matchId,
        agencyId: this.$route.query.agencyId,
        teamId: this.$route.query.teamId,
        cardId: item.cardId
      }
      this.$api.join.delJoinPlayerAll(valData).then(res => {
        if (res.status === 0) {
          this.$message.success('成功')
          this.findData()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    edit (item) {
      this.$router.push({query: {matchId: this.$route.query.matchId, programId: this.$route.query.programId, step: 3, agencyId: this.$route.query.agencyId, teamId: this.$route.query.teamId, cardId: item.cardId}})
    },
    paySuccess () {
      this.findData()
    },
    buyInsurance () {
      if (this.checkCardIds.length === 0) {
        this.$message.error('请选择缴纳保险费的运动员')
        return
      }
      if (!this.bxChecked) {
        this.$message.error('请先阅读并同意《客户告知书》')
        return
      }
      this.$refs.insuranceType.show()
    },
    insuranceTypeOk (insuranceType) {
      let arr = []
      for (let key in this.singleData) {
        if (this.checkCardIds.indexOf(Number(key)) > -1 && this.singleData[key].insuranceStatus !== 1) {
          arr.push(key)
        }
      }
      if (arr.length === 0) {
        this.$message.error('暂无需要缴纳保险费的运动员')
        return
      }
      this.spinning = true
      this.$api.join.createInsuranceOrderByType({matchId: this.$route.query.matchId, agencyId: this.$route.query.agencyId, cardIds: arr, payType: 'PC', insuranceTypeId: insuranceType.insuranceTypeId}).then(res => {
        this.spinning = false
        if (res.status === 0) {
          // 判断是否有需要输入监护人电话的人
          let needPhonePlayers = res.data.needPhonePlayers
          if (needPhonePlayers != null && needPhonePlayers.length > 0) {
            this.needPhonePlayers = []
            needPhonePlayers.forEach(npp => {
              this.needPhonePlayers.push({cardId: npp.cardId, name: npp.name, image: npp.image, phone: undefined})
            })
            this.$refs.buyInsuranceBtn.show()
          } else {
            this.$refs.payQrCode.show(res.data)
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    bxChange (e) {
      this.bxChecked = e.target.checked
    },
    joinOk () {
      if (Object.keys(this.singleData).length === 0) {
        this.$message.error('您还没有参赛运动员，请报名参赛后，下载凭证')
        return
      }
      let playerNumberPass = false
      let combatName = ''
      this.teamData.forEach(element => {
        if (element.playerNumberPass === false) {
          combatName = element.combatName + element.combatDetailName + (element.sex === 1 ? '男子' : (element.sex === 2 ? '女子' : '')) + element.weight + (element.teamNumber > 1 ? element.teamNumber + '小队' : '')
          playerNumberPass = true
        }
      })
      if (playerNumberPass) {
        this.$message.error(combatName + '不满足人数限制，请检查')
        return
      }
      let insuranceBool = false
      // 如果是必须购买保险
      if (this.matchInfo.insuranceStatus === '1') {
        for (let key in this.singleData) {
          if (this.singleData[key].insuranceStatus !== 1) {
            insuranceBool = true
            break
          }
        }
      }
      if (insuranceBool) {
        this.$message.error('您还有运动员没有购买保险，请购买保险后，下载凭证')
        return
      }
      let signBool = false
      if (this.matchInfo.signCostStatus !== 'FREE') {
        for (let key in this.singleData) {
          this.singleData[key].combat.forEach(element => {
            if (element.signStatus !== 1) {
              signBool = true
            }
          })
          if (signBool) {
            break
          }
        }
      }
      if (signBool) {
        this.$message.error('您还有运动员没有缴纳报名费，请缴纳报名费后，下载凭证')
        return
      }
      this.$router.push({query: {matchId: this.$route.query.matchId, programId: this.$route.query.programId, step: 5, agencyId: this.$route.query.agencyId, teamId: this.$route.query.teamId}})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/comm/components/join/heaveCompetition/PaySign.vue